import axios from "axios"; // 引入 axios文件
// import Vrouter from "@/router";
import router from "../router/index";
// const router = Vrouter;

import Vue from "vue";
import { Toast } from "vant";

Vue.use(Toast);

axios.defaults.timeout = 60000; // 请求时间
// var baseURL = "http://52.3.188.205:28080";
// var baseURL = "http://server.big-sight.net:28080";
var baseURL = "https://apibk.smartsketcher-ai.com";

axios.defaults.baseURL = baseURL; // 请求 url

// http request 拦截器
axios.interceptors.request.use(
  config => {
    let USER_TOKEN = localStorage.getItem("token")
      ? localStorage.getItem("token")
      : "";
    config.headers = {
      "Content-Type": "application/json;charset=UTF-8",
      "tenant-Id": "1",
      // "Access-Control-Allow-Origin": "http://site.big-sight.com",
      Authorization: "Bearer " + USER_TOKEN
    };

    // if (USER_TOKEN) {
    //   config.header = {
    //     ...config.header,
    //     Authorization: "Bearer " + USER_TOKEN
    //   };
    // }
    return config;
  }
  // error => {
  //   return Promise.reject(err)
  // }
);

// http response 拦截器
axios.interceptors.response.use(
  response => {
    // console.log("response拦截器", response);
    if (response.data.code == 401) {
      localStorage.removeItem("token");
      router.push({ path: `/login` });
    }
    if (response.data.code == 500) {
      Toast({
        type: "fail",
        icon: "cross",
        message: "システム異常、後で再試行してください"
      });
      setTimeout(() => {
        Toast.clear();
      }, 2000);
      return;
    }
    if (response.data.errCode === 2) {
      // router.push({
      //   path: '/login',
      //   query: { redirect: router.currentRoute.fullPath } // 从哪个页面跳转
      // })
    }
    return response;
  },
  error => {
    Toast.clear();
    return;
    // const { response } = error;
    // let url = response.request.responseURL;
    // if (response.status === 401) {
    //   router.push({
    //     path: "/login"
    //   });
    // }
    // return Promise.reject(error);
  }
);

/**
 * get方法，对应get请求
 * @param {String} url [请求的url地址]
 * @param {Object} params [请求时携带的参数]
 */
export const get = param => {
  return new Promise((resolve, reject) => {
    axios
      .get(param.url, {
        params: param.query || {},
        headers: param.headers || {}
      })
      .then(res => {
        resolve(res);
      })
      .catch(err => {
        reject(err);
      });
  });
};
/**
 * 封装post请求FormData
 * @param url
 * @param data
 * @returns {Promise}
 */
export function postFormData(url, body = {}) {
  function objectToFormData(obj) {
    let formData = new FormData();
    Object.keys(obj).forEach(key => {
      if (obj[key] instanceof Array) {
        obj[key].forEach(item => {
          formData.append(key, item);
        });
        return;
      }
      formData.append(key, obj[key]);
    });
    return formData;
  }
  var params = objectToFormData(body);

  return new Promise((resolve, reject) => {
    axios
      .post(url, params)
      .then(res => {
        resolve(res);
      })
      .catch(err => {
        reject(err);
      });
  });
}

/**
 * 封装post请求
 * @param url
 * @param data
 * @returns {Promise}
 */
export const post = (param, config = {}) => {
  return new Promise((resolve, reject) => {
    axios
      .post(param.url, param.body, config)
      .then(res => {
        resolve(res);
      })
      .catch(err => {
        reject(err);
      });
  });
};

/**
 * 封装post form-data请求
 * @param param
 * @param config
 * @returns {Promise}
 */
export const postFile = (param, config = {}) => {
  config.headers = {};
  config.headers["Content-Type"] = "multipart/form-data";
  console.log("postFile", param.body);
  return new Promise((resolve, reject) => {
    axios
      .post(param.url, param.body, config)
      .then(res => {
        resolve(res);
      })
      .catch(err => {
        reject(err);
      });
  });
};



// WEBPACK FOOTER //
// ./src/http/index.js